import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ApiConnectionsPage } from "src/components/views/ai/apiConnections/ApiConnectionsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/customizations/api-connections")({
	staticData: { title: i18n.t("api_connections"), legacyViewKey: "apiConnectionsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ApiConnectionsPage />;
}
